<template>
  <div class="flex flex-col w-full h-full">
    <!-- Page header -->
    <div class="flex items-center gap-3 px-4 pt-4">
      <span
        class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">domain_add</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">New Corporate</h2>
        <p class="text-sm text-gray-500">Add a new corporate user!</p>
      </div>
    </div>

    <div class="m-4 mt-3">
      <form @submit.prevent="add" class="max-w-3xl">
        <div class="p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
          <div class="space-y-5">
            <!-- Name / Short Name -->
            <div class="grid grid-cols-2 gap-4">
              <label class="block">
                <span class="text-sm font-medium text-gray-600">Name</span>
                <input
                  v-model="name"
                  class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                  placeholder="Sheraton Addis"
                />
              </label>
              <label class="block">
                <span class="text-sm font-medium text-gray-600"
                  >Short Name</span
                >
                <input
                  v-model="shortName"
                  minlength="3"
                  maxlength="3"
                  class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                  placeholder="SHR"
                />
              </label>
            </div>

            <!-- Email -->
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Email</span>
              <input
                v-model="email"
                class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                placeholder="Corporate email"
              />
            </label>

            <!-- Price per KM / Price per Min -->
            <div class="grid grid-cols-2 gap-4">
              <label class="block">
                <span class="text-sm font-medium text-gray-600"
                  >Price per KM</span
                >
                <input
                  v-model="pricing.pricePerKM"
                  class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                  placeholder="10"
                />
              </label>
              <label class="block">
                <span class="text-sm font-medium text-gray-600"
                  >Price Per Min</span
                >
                <input
                  v-model="pricing.pricePerMin"
                  class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                  placeholder="10"
                />
              </label>
            </div>

            <!-- Base Fare -->
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Base Fare</span>
              <input
                v-model="pricing.baseFare"
                class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
                placeholder="10"
              />
            </label>
          </div>

          <!-- Footer -->
          <div
            class="flex items-center justify-end gap-3 pt-5 mt-6 border-t border-gray-200"
          >
            <back-button></back-button>
            <button
              :disabled="busy"
              class="inline-flex items-center justify-center h-10 px-6 text-sm font-semibold text-white transition-colors duration-150 rounded-xl shadow-sm"
              :class="
                busy
                  ? 'bg-taxiye-200 cursor-not-allowed'
                  : 'bg-taxiye-500 hover:bg-taxiye-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";

export default {
  components: {
    BackButton,
  },
  data() {
    return {
      busy: false,
      name: "",
      email: "",
      shortName: "",
      pricing: {
        pricePerKM: null,
        pricePerMin: null,
        baseFare: null,
      },
    };
  },
  methods: {
    add() {
      if (this.name && this.shortName && this.shortName.length == 3) {
        this.busy = true;
        this.$http
          .post("/corporates", {
            name: this.name,
            email: this.email,
            shortName: this.shortName.toLowerCase(),
            pricing: this.pricing,
          })
          .then(() => this.$router.push("/corporate"))
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    },
  },
};
</script>
